import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AuthSevices } from '@fitness-force/api';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { BehaviorSubject } from 'rxjs';
import Statsig from 'statsig-js';

@Component({
  selector: 'actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [    CommonModule,
    ButtonModule,
    PopoverModule,
    TranslateModule
  ]
})

export class ActionsComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null) 
  @Input() rowIndex = 0;
  @ViewChild('listContainer')
  listContainer!: ElementRef;

  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }
  showOptions = false;
  currentUserDetails: any;
  showSalesReturn=  new BehaviorSubject(false);
  showRefund= new BehaviorSubject(false);
  showWriteOff= new BehaviorSubject(false);

  constructor(private authService: AuthSevices, public cdr : ChangeDetectorRef) { }

  ngOnInit(): void {
    this.currentUserDetails = this.authService.decodedToken;
    if(Statsig.checkGate("show_salesreturn")){
      this.showSalesReturn.next(true);
    }
    else{
      this.showSalesReturn.next(true);
    }

    if(Statsig.checkGate("show_refund")){
      this.showRefund.next(true);
    }
    else{
      this.showRefund.next(false);
    }
    if(Statsig.checkGate("show_writeoff")){
      this.showWriteOff.next(true);
    }
    else{
      this.showWriteOff.next(false);
    }
  }


  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  executeAction(action: string, columnData: any, overlayElement: any) {
    overlayElement.hide();
    this.onAction.emit({ action, columnData: columnData, rowIndex: this.rowIndex });
  }

  isActive(columnData: any): boolean {
    return columnData.status.toUpperCase() == 'Active'.toUpperCase()
  }

  isStatusVoid(columnData: any): boolean {
    return columnData.status.toLowerCase() == "void";
  }

  showRefundOption(columnData: any):boolean
  {
    return columnData.status.toLowerCase() != "open" && columnData.status.toLowerCase() != "void" && columnData.status.toLowerCase() != "refunded";
  }

  isRefundStatusVoid(columnData: any): boolean {
    return columnData.refund_isvoid;
  }

  isStatusPartialOrOpen(columnData: any): boolean {
    return columnData.status.toLowerCase() == "partialopen" || columnData.status.toLowerCase() == "open";
  }

  get hasAdminBilling(): boolean {
    return this.currentUserDetails.can_admin_billing == 'true' ? true : false;
  }

  hasListItems(): boolean {
    console.log(this.listContainer?.nativeElement?.querySelectorAll('li').length > 0);
    return this.listContainer?.nativeElement?.querySelectorAll('li').length > 0;
  }

  hasBalanceAmount(columnData: any): boolean {
    return columnData.total_balance_due_in_minor_currency && columnData.total_balance_due_in_minor_currency > 0;
  }

  showStopCampaign(columnData: any): boolean {
    return columnData.campaign_status.toLowerCase() == "inprogress";
  }

  showVoidCampaign(columnData: any): boolean {
    return columnData.campaign_status.toLowerCase() == "scheduled";
  }

}
